import styled, { useTheme } from "styled-components";
import { ProjectsKanbanColumn } from "./ProjectsKanbanColumn";
import { ProjectsKanbanCard } from "./ProjectsKanbanCard";

export const ProjectsKanban = ({projects}) => {

    const GlobalTheme = useTheme();
    
    return (
        <StyledProjectsKanban>
            <ProjectsKanbanColumn
                id="projects-kanban-active"
                title="Aktive prosjekter"
                counter={projects.filter(prj => prj && prj.projectStatus === "Active").length}
                color={GlobalTheme.colors.neutralSecondaryForeground}
            >
                {projects.map(prj => prj && prj.projectStatus === "Active" ? <ProjectsKanbanCard key={prj.projectUuid} project={prj}/> : null)}
            </ProjectsKanbanColumn>

            <ProjectsKanbanColumn
                id="projects-kanban-inactive"
                title="Inaktive prosjekter"
                counter={projects.filter(prj => prj && prj.projectStatus === "Inactive").length}
                color={GlobalTheme.colors.warningForeground}
            >
                {projects.map(prj => prj && prj.projectStatus === "Inactive" ? <ProjectsKanbanCard key={prj.projectUuid} project={prj}/> : null)}
            </ProjectsKanbanColumn>

            <ProjectsKanbanColumn
                id="projects-kanban-finished"
                title="Fullførte prosjekter"
                counter={projects.filter(prj => prj && prj.projectStatus === "Finished").length}
                color={GlobalTheme.colors.successForeground}
            >
                {projects.map(prj => prj && prj.projectStatus === "Finished" ? <ProjectsKanbanCard key={prj.projectUuid} project={prj}/> : null)}
            </ProjectsKanbanColumn>
        </StyledProjectsKanban>
    )
}

const StyledProjectsKanban = styled.div`
    display: flex;
    height: 100%;
    overflow: hidden;
`